import { Phone, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/lib/constants";
import { HOME_IDS } from "@/constants/testIds/site";

export default function FloatingCTA() {
  return (
    <div className="fixed z-50 bottom-4 right-4 sm:bottom-6 sm:right-6 flex flex-col gap-3">
      <a
        href={`https://wa.me/${BUSINESS.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid={HOME_IDS.floatingWhatsapp}
        className="group w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transition-transform duration-200 active:scale-95"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="sr-only">WhatsApp</span>
      </a>
      <a
        href={`tel:${BUSINESS.phone}`}
        aria-label="Call now"
        data-testid={HOME_IDS.floatingCall}
        className="group w-14 h-14 rounded-full bg-[#0057B8] text-white grid place-items-center shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transition-transform duration-200 active:scale-95"
      >
        <Phone className="w-6 h-6" />
        <span className="sr-only">Call</span>
      </a>
    </div>
  );
}
